import type { BookingStatusProperty } from '@cocoonspace/sdk-js/types/bookingStatusProperty'
import type React from 'react'
import { Badge } from '@cocoonspace/ui/components/badge'
import { useLingui } from '@lingui/react/macro'

export const QuotationStatus = ({
	status,
}: {
	status: BookingStatusProperty
}) => {
	const { t } = useLingui()

	const label = (() => {
		switch (status) {
			case 'new':
				return t`Nouveau`
			case 'require_validation':
				return t`À valider`
			case 'validated':
				return t`Validé`
			case 'require_payment':
				return t`Paiement requis`
			case 'require_refund':
				return t`Remboursement requis`
			case 'balanced':
				return t`Soldé`
			case 'invoiced':
				return t`Facturé`
			case 'cancelled':
				return t`Annulé`
			case 'expired':
				return t`Expiré`
			default:
				return status
		}
	})()

	const variant: React.ComponentProps<typeof Badge>['variant'] =
		status === 'require_validation'
			? 'primary'
			: status === 'expired' || status === 'cancelled'
				? 'error'
				: 'secondary'

	return (
		<Badge
			variant={variant}
			size='sm'
		>
			{label}
		</Badge>
	)
}
